<template>
  <!-- Modal Component -->
  <b-modal
    id="modal_buscadocfiscal"
    ref="modal_buscadocfiscal"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModalBuscarDocFiscal"
    :ok-disabled="form.errors.any()"
    size="lg"
  >
    <b-container fluid class="p-a-0">
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <div class="row p-t" v-if="vuetableFilterRow">
          <vuetable-filterbar> </vuetable-filterbar>
        </div>
        <div class="row loadingDataPosition">
          <div class="loadingData" v-if="loadingDataFiscal">
            <div class="loadingDataSpinner">
              <spinner
                v-if="loadingDataFiscal"
                text-fg-color="#ffffff"
                message="Carregando..."
              ></spinner>
            </div>
          </div>
          <vuetable
            ref="vuetable"
            api-url="/api/associardocumentodespesa/doctransp"
            :fields="fields"
            :css="css"
            :append-params="moreParams"
            track-by="doctransp_id"
            pagination-path=""
            @vuetable:load-error="onError"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loaded="onLoaded"
          >
            <template slot="status_uc" slot-scope="props">
              <span
                class="badge badge-info"
                v-if="props.rowData.status.valor == 1"
                >{{ props.rowData.status.descr }}</span
              >
              <span
                class="badge badge-warning"
                v-if="props.rowData.status.valor == 2"
                >{{ props.rowData.status.descr }}</span
              >
              <span
                class="badge badge-success"
                v-if="props.rowData.status.valor == 3"
                >{{ props.rowData.status.descr }}[
                {{ props.rowData.carga_doc_unidade_carga.length }} ]
              </span>
              <span
                class="badge badge-danger"
                v-if="props.rowData.status.valor == 4"
                >{{ props.rowData.status.descr }}</span
              >
            </template>
            <template slot="vlr_cte" slot-scope="props">
              <span>{{
                  formatNumber(
                    props.rowData.doc_transp_vlr_prestacao.vlr_receber
                  )
                }}</span
              >
            </template>

            <template slot="actions" slot-scope="props">
              <div class="custom-actions">
                <a
                  @click="sendDoc(props.rowData)"
                  v-b-tooltip
                  title="Selecionar"
                  ><i class="fa fa-check"></i
                ></a>
              </div>
            </template>
            <template slot="dt_emissao" slot-scope="props">
              <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
            </template>
          </vuetable>
        </div>

        <div class="row m-t">
          <div class="col-md-12">
            <div class="pull-left pagination-detail">
              <vuetable-pagination-info
                ref="paginationInfo"
                :css="css.pagination"
                info-class="pull-left"
              ></vuetable-pagination-info>
            </div>
            <div class="pull-right m-a-0">
              <vuetable-pagination
                ref="pagination"
                :css="css.pagination"
                @vuetable-pagination:change-page="onChangePage"
              ></vuetable-pagination>
            </div>
          </div>
        </div>
      </form>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Associando..."></spinner>
      </div>
      <div class="float-right">
        <div class="float-left" v-if="this.errors_array.length > 0">
          <b-btn
            class="badge badge-warning"
            @click="showPopover = !showPopover"
            id="popoverButton-sync"
            v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'"
            variant="warning"
            ><i class="fa fa-exclamation-triangle fa-2x"></i
          ></b-btn>

          <b-popover
            :show.sync="showPopover"
            target="popoverButton-sync"
            title="<strong>Erros Encontrados</strong>"
            data-html="true"
            placement="leftbottom"
          >
            <table class="table" id="mais">
              <tbody>
                <tr
                  class="bg-gray-light"
                  style="display: table-row"
                  v-for="item in this.errors_array"
                >
                  <td>
                    {{ item.erro }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-popover>
        </div>
        &nbsp;
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import BuscarDocFiscalFilterBar from "../components/BuscarDocFiscalFilterBar";
import AssociarDocumentoDespesaModalBuscaFilterBar from "./AssociarDocumentoDespesaModalBuscaFilterBar.vue";
import accounting from "accounting";
import { VMoney } from "v-money";
import moment from "moment";

export default {
  components: {
    VMoney,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": AssociarDocumentoDespesaModalBuscaFilterBar,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingDataFiscal: true,
      showPopover: false,
      showModalBuscarDocFiscal: false,
      docs: [],
      errors_array: [],
      form: new Form({
        cst: [],
        chave_cte_multi: "",
        chave: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_doc",
          title: "Nº Fiscal",
        },
        {
          name: "serie",
          title: "Serie",
        },
        {
          name: "__slot:vlr_cte",
          title: "Valor Cte",
        },
        {
          name: "__slot:dt_emissao",
          title: "Data Emissão",
        },
        {
          name: "doc_transp_partes_env.emi_cnpj",
          title: "CNPJ Emitente",
        },
        {
          name: "doc_transp_partes_env.emi_nome",
          title: "Razão Social Emitente",
        },
        {
          name: "doc_transp_partes_env.des_cnpj",
          title: "CNPJ Destinatário",
        },
        {
          name: "doc_transp_partes_env.des_nome",
          title: "Razão Social Destinatário",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  directives: {
    money: VMoney,
    aliquota: VMoney,
    qtd: VMoney,
    percentual_reducao_bc: VMoney,
  },
  mounted() {
    this.$events.$on("filterModal-set", (eventData) =>
      this.onFilterSet(eventData)
    );
    this.$events.$on("filterModal-reset", (e) => this.onFilterReset());
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingDataFiscal = true;
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        emi_cnpj: data_filter.emi_cnpj,
        emi_nome: data_filter.emi_nome,
        des_cnpj: data_filter.des_cnpj,
        des_nome: data_filter.des_nome,
        chave: data_filter.chave,
        dt_inicio: data_filter.dt_inicio,
        dt_fim: data_filter.dt_fim,
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingDataFiscal = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
      //this.loadingDataFiscal = false;
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingDataFiscal = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    sendDoc(data) {
      this.$events.fire("popula-grid", data);
      this.$refs.modal_buscadocfiscal.onClose();
    },
    onBuscarDocFiscal(data) {
      this.loadingDataFiscal = true;
      this.form.reset();
      this.$refs.modal_buscadocfiscal.show();
    },
    formatNumberInterno(value) {
      return accounting.formatNumber(value, 2, ",", ".");
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberQtd(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
